import { configureStore } from '@reduxjs/toolkit'
import { Action as ReduxAction } from 'redux'
import { persistStore, persistReducer } from 'redux-persist'
import { persistConfig } from './persistConfig'
import config from '@configs'

// middleware
import createSagaMiddleware from 'redux-saga'

// reducer
import reducers from '@redux/store/index'

// saga
import rootSaga from './saga'

export interface Action extends ReduxAction {
	value: any
}

export type RootState = ReturnType<typeof reducers>

// middleware
const sagaMiddleware = createSagaMiddleware()
const middlewares = [sagaMiddleware]

// logger
if (config.get('isDevEnv')) {
	/* eslint-disable */
	const { logger } = require('redux-logger')
	middlewares.push(logger)
}

// reducers
const rootReducer = (state: RootState, action: ReduxAction) => {
	return reducers(state, action)
}

// persist
const persistedReducer = persistReducer(persistConfig, rootReducer)

// store
const store = configureStore({
	reducer: persistedReducer,
	middleware: [...middlewares],
})

export const persistor = persistStore(store)
export default store

sagaMiddleware.run(rootSaga)
